import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { Button, Form, Container, Image, Popup, Divider, Message, Accordion, Loader } from 'semantic-ui-react'
import smoothscroll from 'smoothscroll-polyfill'
import SearchResult from '../Search/result'
import { pushFeedback, delFeedback } from '../../actions/actionCreators'
import { backendService } from '../../services/backendService'
import Logo from '../../images/logo-admin.png'
import { Text, Translate, LanguageContext } from '../../helpers/language';

class ProjectDetails extends React.Component {

  constructor() {
    super()
    smoothscroll.polyfill();
    this.handleClick = this.handleClick.bind(this)
    this.createFeedback = this.createFeedback.bind(this)
    this.handleDeleteElement = this.handleDeleteElement.bind(this)
    this.deleteFeedback = this.deleteFeedback.bind(this)
    this.printResult = this.printResult.bind(this);
    this.state = {
      elements: [],
      error: false,
      activeIndex: -1,
      deletedElement: false,
      loading: false
    }
  }

  componentDidMount() {
    this.getElements()
  }

  async getElements() {
    this.setState({ loading: true })
    const response = await backendService.get(`/api/projects/${this.props.location.state.id}/elements`)
    this.setState({ loading: false })

    if (response.data) {
      this.setState({ elements: response.data })
    } else {
      this.setState({ error: Translate(this.context, 'generic_fail_message') })

      this.hideMessage()
    }
  }

  async handleDeleteElement(idResult) {
    const response = await backendService.delete(`/api/projects/elements/${this.props.location.state.id}/${idResult}`);

    if (response.data.success == true) {
      this.setState({ deletedElement: true })

      var newElements = this.state.elements.filter(function (obj) {
        return obj.idResult !== idResult;
      });

      this.setState({ elements: newElements })

      const self = this
      setTimeout(function () {
        self.setState({ deletedElement: false })
      }, 3000)
    }
  }

  hideMessage() {
    const self = this
    setTimeout(function () {
      self.setState({ error: false })
    }, 3000)
  }

  handleClick = (e, titleProps, callback) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index
    this.setState({ activeIndex: newIndex })
    if (callback) {
      callback(newIndex === index)
    }
  }

  createFeedback = (idSite, result, positive, query, comment, callback) => {
    this.props.dispatch(pushFeedback({
      user: this.props.auth.user.email,
      idResult: idSite,
      query: query,
      result: result,
      positive: positive,
      comment: comment
    })).then(() => { callback() })
  }

  deleteFeedback = (idSite, callback) => {
    this.props.dispatch(delFeedback({
      user: this.props.auth.user.email,
      idResult: idSite
    })).then(() => { callback() })
  }

  printResult(content_div, carousel_div) {
    var contents = document.getElementById(content_div).innerHTML;
    var carousel = document.getElementById(carousel_div);
    if( carousel != null) {
      carousel = carousel.innerHTML
    }
    var frame1 = document.createElement('iframe');
    frame1.name = "frame1";
    frame1.style.position = "absolute";
    frame1.style.top = "-1000000px";
    document.body.appendChild(frame1);
    var frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
    frameDoc.document.open();
    frameDoc.document.write('<html><head><title>LISIA</title>');
    frameDoc.document.write('</head><body>');
    if( carousel != null ) {
      frameDoc.document.write('<b>MASSIMA</b>') ;
      frameDoc.document.write('<div>' + carousel + '</div>') ;
      frameDoc.document.write('<hr />') ;
    }
    frameDoc.document.write('<div>' + contents + '</div>');
    frameDoc.document.write('</body></html>');

    //remove close button form printed document
    const element = frameDoc.document.querySelector('div[id^=return_button]')
    if (element)
      element.parentNode.removeChild(element);

    frameDoc.document.close();
    setTimeout(function () {
      window.frames["frame1"].focus();
      window.frames["frame1"].print();
      document.body.removeChild(frame1);
    }, 500);
    return false;
  }

  render() {
    const error = this.state.error
    const deletedElement = this.state.deletedElement

    return (
      <Row>
        <Col xs={8} sm={4} md={3} className='lisia-app-logo-wrapper'>
          <Link to='/'>
            <Image src={ Logo } />
          </Link>
        </Col>
        <Col className="lisia-app-card-content projectDetails centered" xs={12} md={10} >
          {error &&
            <Message
              warning
              header={error}
            />
          }
          {deletedElement &&
            <Message
              warning
              header={Translate(this.context, 'folder_element_deleted')}
            />
          }
          <div className='lisia-app-header'>
            <div className='header'>
              <Link to='/projects'>
                <Text tid="back" />
              </Link>            
            </div>          
            <h3 className='text-center lisia-app-card-title'>{this.props.location.state.name}</h3>
          </div>             
          <Divider />
          {this.state.loading &&
            <Loader active inline='centered' className='marginLoadMore' />
          }
          {this.state.elements.length > 0 &&
            <Accordion fluid className='m-tb-20'>
              {this.state.elements.map((element, i) => {
                return (
                  <div key={'elementresult-' + i}>
                    <p><i>{element.query}</i></p>
                    {<SearchResult
                      key={'elementresult-' + i}
                      activeIndex={this.state.activeIndex}
                      handleClick={this.handleClick}
                      result={JSON.parse(element.result)}
                      article_type={'law'}
                      i={i}
                      deleteFeedback={this.deleteFeedback}
                      heightOffset={0}
                      createFeedback={this.createFeedback}
                      query={element.query}
                      handleDeleteElement={this.handleDeleteElement}
                      projects={[]}
                      printResultFnc={this.printResult}
                    />}
                  </div>
                )
              })}
            </Accordion>
          }
        </Col>
      </Row>
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
})

ProjectDetails.contextType = LanguageContext;

export default connect(mapStateToProps)(ProjectDetails)